// extracted by mini-css-extract-plugin
export default {"learner-name":"DeleteLearerRecord_learner-name__ZFhsw","row--pipe-separated":"DeleteLearerRecord_row--pipe-separated__HTlcp","question":"DeleteLearerRecord_question__ZW5CO"};